import { Platform } from "@angular/cdk/platform";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class BrowserService {
  constructor(private readonly platform: Platform) {}

  get isBlink() {
    return this.platform.BLINK;
  }

  get isEdge() {
    return this.platform.EDGE;
  }
}
